import React from "react";
import { useLocation } from "react-router-dom";

// components
import NavbarSearchUser from "components/Navbars/NavbarSearchUser.js";
import HeaderStatCards from "components/Headers/Admin/HeaderStatCards.js";
import CardFullTable from "components/Cards/Admin/CardFullTable.js";
import FooterAdmin from "components/Footers/Admin/FooterAdmin.js";
// texts as props
import navbarsearchusersettings2 from "_texts/admin/navbars/navbarsearchusersettings2.js";
import headerstatcards from "_texts/admin/headers/headerstatcards.js";
import cardfulltable from "_texts/admin/cards/cardfulltable.js";
import footeradmin from "_texts/admin/footers/footeradmin.js";

export default function Tables() {
  const location = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return (
    <div>
      <NavbarSearchUser {...navbarsearchusersettings2} />
      <HeaderStatCards {...headerstatcards} />
      <div>
        <div>
          <div>
            <CardFullTable {...cardfulltable} />
          </div>
          <div>
            <CardFullTable {...cardfulltable} color="blueGray" />
          </div>
        </div>
        <FooterAdmin {...footeradmin} />
      </div>
    </div>
  );
}
